import { getMonitorStatusOutlineColorHex, MonitorStatus } from '@fe/core';
import type { SortDescriptor } from '@progress/kendo-data-query';
import { type CSSProperties, useCallback } from 'react';
import { UDViewTagSelectionEnum } from '../../../udView/udview';
import { dashboardFlightFilters } from '../../utils/dashboard';
import { DashboardCustomColumn, type DashboardFlightColumn, DashboardFlightsPanel } from './DashboardFlightsPanel';

const columns: DashboardFlightColumn[] = [
    { id: 'acid', field: 'normalizedAcid', title: 'Aircraft ID', tagSelector: UDViewTagSelectionEnum.Acid },
    { id: 'acType', field: 'aircraftType', title: 'AcType', tagSelector: UDViewTagSelectionEnum.AircraftType },
    { id: 'origin', field: 'origin', title: 'Origin', tagSelector: UDViewTagSelectionEnum.Origin },
    { id: 'destination', field: 'destination', title: 'Dest', tagSelector: UDViewTagSelectionEnum.Destination },
    { id: 'etaFAA', field: 'arrivalTime', title: 'ETA', tagSelector: UDViewTagSelectionEnum.EtaFaa },
    {
        id: 'ssinceposupdt',
        field: 'lastPositionReportTime',
        title: 'Last pos',
        tagSelector: UDViewTagSelectionEnum.SincePositionUpdate
    }
];

const defaultSort: SortDescriptor[] = [{ field: 'lastPositionReportTime', dir: 'desc' }];

export function PositionUpdatedFlightList() {
    const getCellStyle = useCallback(
        (
            column: DashboardFlightColumn | DashboardCustomColumn,
            _value: unknown,
            row: { positionUpdatedMonitorStatus?: MonitorStatus | null }
        ): CSSProperties | undefined => {
            if (column.id !== 'ssinceposupdt') {
                return undefined;
            }

            const status = row.positionUpdatedMonitorStatus;

            if (status == null || status === MonitorStatus.null) {
                return undefined;
            }

            const color = getMonitorStatusOutlineColorHex(status);

            return {
                backgroundColor: `color-mix(in srgb, ${color} 25%, var(--kendo-color-surface))`,
                color: 'var(--kendo-color-on-surface)',
                fontWeight: 700,
                boxShadow: `inset 0 -2px 0 ${color}`
            };
        },
        []
    );

    return (
        <DashboardFlightsPanel
            title="Late position update flights"
            flightFilters={dashboardFlightFilters['position-updated']}
            columns={columns}
            defaultSort={defaultSort}
            variant="position-updated"
            customColumns={[]}
            emptyText="No position updated flights"
            getCellStyle={getCellStyle}
            includeLastPositionTimeMonitorStatus
        />
    );
}
